import { render } from "./WorkspacePage.vue?vue&type=template&id=792ab05e&scoped=true"
import script from "./WorkspacePage.vue?vue&type=script&lang=js"
export * from "./WorkspacePage.vue?vue&type=script&lang=js"

import "./WorkspacePage.vue?vue&type=style&index=0&id=792ab05e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-792ab05e"]])

export default __exports__